import { render, staticRenderFns } from "./TableVerticalAd.vue?vue&type=template&id=dc3a90a4"
import script from "./TableVerticalAd.vue?vue&type=script&lang=js"
export * from "./TableVerticalAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports